// import {
//   faCheckCircle,
//   faInfo,
//   faWarning,
// } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { Form, Col, Row, Segmented } from "antd";
import useGet from "../../../global/hooks/useGet";
import usePost from "../../../global/hooks/usePost";
import usePut from "../../../global/hooks/usePut";
import useDelete from "../../../global/hooks/useDelete";
import CustomInput from "../../../global/components/inputWidgets/CustomInput";
import CustomSelect from "../../../global/components/inputWidgets/CustomSelect";
import { useNavigate, useParams } from "react-router-dom";
import {
  openConfirmNotification,
  openErrorNotification,
  showToast,
} from "../../../global/utils/toast";

import {
  CheckCircleOutlined,
  CloseOutlined,
  DesktopOutlined,
  FolderOpenOutlined,
  DeleteOutlined,
  EditOutlined,
  UnorderedListOutlined,
  InfoCircleOutlined,
  SettingOutlined,
  OrderedListOutlined,
  DollarOutlined,
} from "@ant-design/icons";
import CustomCheckbox from "../../../global/components/inputWidgets/CustomCheckBox";
// import CustomSwitch from "../../../global/components/inputWidgets/CustomSwitch";
import CommonBreadcrumb from "../../../global/components/CommonBreadcrumb";
import CommonButton from "../../../global/components/CommonButton";
import CommonModal from "../../../global/components/CommonModal";
import { LicenseSelectForm } from "./LicenseSelectForm";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
import ConfirmModal from "../../../global/components/ConfirmModal";
import DeviceIcon from "../../../assets/images/vectors/SideBarIcons/DeviceIcon";
import LicenseIcon from "./../../../assets/images/vectors/SideBarIcons/LicenseIcon";
import SingleSelectCheckboxGroup from "../../../global/components/inputWidgets/SingleSelectCheckboxGroup";
import CustomTextArea from "../../../global/components/inputWidgets/CustomTextArea";
import AccountCreationModal from "../../../global/components/AccountCreationModal";
import OemIcon from "../../../assets/images/vectors/SideBarIcons/OemIcon";
import DealerIcon from "../../../assets/images/vectors/SideBarIcons/DealerIcon";
import AccountIcon from "../../../assets/images/vectors/SideBarIcons/AccountIcon";
import { macValidator } from "../../../global/utils/macValidator";
import DeviceLogIcon from "../../../assets/images/vectors/SideBarIcons/DeviceLogIcon";
import PaymentIcon from "../../../assets/images/vectors/SideBarIcons/PaymentIcon";
import { GlobalTable } from "../../../global/components/GlobalTable";
import { DeviceLogItemColumns } from "../Page/DeviceLogItemColumns";
import { DeviceOrderItemColumns } from "../Page/DeviceOrderItemColumns";
import OrderItemIcon from "../../../assets/images/vectors/SideBarIcons/OrderItemIcon";
import OrderIcon from "../../../assets/images/vectors/SideBarIcons/OrderIcon";
import { LuShoppingBag } from "react-icons/lu";
import { hasRole } from "../../../global/hooks/getUserRole";

export const DeviceForm = ({ type }) => {
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const [showModal, setShowModal] = useState(false);
  const [showCommonModal, setShowCommonModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [OemNo, setOemNo] = useState(null);
  const [dealerNo, setDealerNo] = useState(null);
  const deviceTabs = [
    {
      label: "Device Logs",
      value: "deviceLog",
      icon: <OrderedListOutlined />,
    },
    { label: "Orders", value: "order", icon: <LuShoppingBag /> },
  ];
  const [tabValue, setTabValue] = useState(deviceTabs[0].value);
  // const [selectedValues, setSelectedValues] = useState([]);
  // const [defaultOptionsValue, setDefaultOptionsValue] = useState([]);
  // const [deafultModel, setDeafultModel] = useState(null);
  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const [sitetype, setSiteType] = useState(hasRole(7, 8, 9) ? 3 : 0);
  const [nodeType, setNodeType] = useState(1);
  const [licenseSiteType, setLicenseSiteType] = useState(null);
  // const [defaultLicenseDevicesValue, setDefaultLicenseDevicesValue] = useState({
  //   channels: null,
  //   facegates: null,
  //   locksets: null,
  //   contlocks: null,
  //   subnodes: null,
  //   intercoms: null,
  //   sicucoms: null,
  //   invitations: null,
  //   storages: null,
  // });
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [defaultData, setDefaultData] = useState({
    DealerNo: null,
    OemNo: null,
    CustomerNo: null,
    // ProductionNo: null,
  });

  const url = id
    ? `${process.env.REACT_APP_API_URL}/api/devices/${id}/`
    : `${process.env.REACT_APP_API_URL}/api/devices/`;
  // const licenseInfoUrl =
  //   selectedRow.length > 0 && selectedRow[0]?.LicenseNo
  //     ? `${process.env.REACT_APP_API_URL}/api/license/${selectedRow[0].LicenseNo}`
  //     : null;
  const licenseInfoUrl =
    selectedRow[0]?.LicenseNo &&
    `${process.env.REACT_APP_API_URL}/api/licenses/${selectedRow[0]?.LicenseNo}/`;
  const optionUrl = `${process.env.REACT_APP_API_URL}/api/devices/options/`;
  // const postUrl = `${process.env.REACT_APP_API_URL}/api/devices/`;
  // const putUrl = `${process.env.REACT_APP_API_URL}/api/devices/${id}/`;
  // const deleteUrl = `${process.env.REACT_APP_API_URL}/api/devices/${id}/`;
  const { data, loading, error, refetch } = useGet(id ? url : null);
  // console.log("data", data);
  const { data: individualLicenseData, error: individualLicenseError } =
    useGet(licenseInfoUrl);

  const deviceLogParams = {
    limit: 20,
    sort_by: "LogNo",
    order: "desc",
    DeviceNo: id,
  };
  const deviceLogQuery = new URLSearchParams(deviceLogParams).toString();
  const deviceLogUrl = id
    ? `${process.env.REACT_APP_API_URL}/api/devicelogs/?${deviceLogQuery}`
    : null;
  const {
    data: deviceLogData,
    loading: deviceLogLoading,
    error: deviceLogError,
  } = useGet(deviceLogUrl);

  // const deviceLogOrderParams = {
  //   limit: 20,
  //   sort_by: "LogNo",
  //   order: "desc",
  //   DeviceNo: id,
  // };
  // const deviceLogOrderQuery = new URLSearchParams(
  //   deviceLogOrderParams
  // ).toString();
  const deviceLogOrderUrl =
    id && tabValue === "order"
      ? `${process.env.REACT_APP_API_URL}/api/${id}/orders/`
      : null;
  const {
    data: deviceLogOrderData,
    loading: deviceLogOrderLoading,
    error: deviceLogOrderError,
  } = useGet(deviceLogOrderUrl);

  const {
    data: optionsData,
    error: optionDataError,
    refetch: optionDataRefetch,
  } = useGet(optionUrl);

  // console.log(optionsData);

  const {
    data: postData,
    error: postError,
    postData: postAction,
    loading: postLoading,
  } = usePost(url);
  const {
    data: putData,
    error: putError,
    putData: putAction,
    loading: putLoading,
  } = usePut(url);
  const {
    data: deletedData,
    error: deletedDataError,
    deleteData,
  } = useDelete(url);

  const dealerOptionsUrl =
    OemNo || data?.data?.OemNo || defaultData?.OemNo
      ? `${process.env.REACT_APP_API_URL}/api/dealers/oems/${
          OemNo
            ? OemNo
            : defaultData?.OemNo
            ? defaultData.OemNo
            : data?.data?.OemNo
        }/dealers/`
      : null;

  const {
    data: dealerOptions,
    loading: dealerOptionsLoading,
    error: dealerOptionsError,
    refetch: delaerOpRefetch,
  } = useGet(dealerOptionsUrl);

  const custmerOptionsUrl =
    dealerNo || data?.data?.DealerNo || defaultData?.DealerNo
      ? `${process.env.REACT_APP_API_URL}/api/dealers/${
          dealerNo
            ? dealerNo
            : defaultData?.DealerNo
            ? defaultData.DealerNo
            : data?.data?.DealerNo
        }/customers/`
      : null;

  const {
    data: custmerOptions,
    loading: custmerOptionsLoading,
    error: custmerOptionsError,
    refetch: customerDataRefetch,
  } = useGet(custmerOptionsUrl);

  // const licenseOptionUrl = `${process.env.REACT_APP_API_URL}/api/licenses/getoptions/`;

  // const {
  //   data: licenseOptionsData,
  //   loading: licenseOptionsLoading,
  //   error: licenseOptionsError,
  // } = useGet(licenseOptionUrl);

  // console.log("licenseOptionsData", licenseOptionsData);
  // console.log("dealerOptions", custmerOptions);
  // console.log(form.getFieldValue("DealerNo"));

  const modifiedProducts = getModifiedResponse(optionsData, "products");
  const modifiedModels = getModifiedResponse(optionsData, "models");
  const modifiedOems = getModifiedResponse(optionsData, "oems");
  // const modifiedProductions = getModifiedResponse(optionsData, "productions");
  // const modifieOp = getModifiedResponse(optionsData, "options");
  const modifiedSiteTypes = hasRole(7, 8, 9)
    ? getModifiedResponse(optionsData, "sitetype").filter((item) =>
        [3, 4].includes(item.value)
      )
    : getModifiedResponse(optionsData, "sitetype");
  const modifiedNodeTypes = getModifiedResponse(optionsData, "nodetype");
  const modifiedDealers = getModifiedResponse(dealerOptions, null);
  const modifiedCustomers = getModifiedResponse(custmerOptions, null);

  // const modifiedLicenseOptions = getModifiedResponse(
  //   licenseOptionsData,
  //   "options"
  // );
  const modifiedOp = optionsData?.data?.options?.map((entry, index) => {
    // const safeName = entry?.name?.replace(/\s+/g, "_")?.toLowerCase();
    // const safeTag = entry?.tag?.replace(/\s+/g, "_")?.toLowerCase();

    return {
      value: `${entry?.value}`,
      // tag: entry.tag.toLowerCase().replace(/\s+/g, ""),
      label: entry.name,
    };
  });
  // console.log(userData);

  useEffect(() => {
    if (hasRole(7, 8, 9)) {
      setOemNo(userData?.oem_no);
      setDealerNo(userData?.dealer_no);
    }
  }, []);

  // const modifiedOpValues =
  //   selectedValues?.length > 0
  //     ? selectedValues.map((val) => {
  //         const [item, originalValue] = val?.split("-");
  //         return [Number(item), Number(originalValue)];
  //       })
  //     : [];

  // const createModifiedOptions = (data, key) => [
  //   // { label: "N/A", value: null },
  //   ...getModifiedResponse(data, key),
  // ];

  // const modifiedOptions = {
  //   channels: createModifiedOptions(optionsData, "channels"),
  //   facegates: createModifiedOptions(optionsData, "facegates"),
  //   locksets: createModifiedOptions(optionsData, "locksets"),
  //   contLocks: createModifiedOptions(optionsData, "contlocks"),
  //   subnodes: createModifiedOptions(optionsData, "subnodes"),
  //   intercoms: createModifiedOptions(optionsData, "intercoms"),
  //   sicucoms: createModifiedOptions(optionsData, "sicucoms"),
  //   invitations: createModifiedOptions(optionsData, "invitations"),
  //   storages: createModifiedOptions(optionsData, "storages"),
  // };
  // const {
  //   channels: modifiedChannels,
  //   facegates: modifiedFacegates,
  //   locksets: modifiedLocksets,
  //   contLocks: modifiedContLocks,
  //   subnodes: modifiedSubnodes,
  //   intercoms: modifiedIntercoms,
  //   sicucoms: modifiedSicucoms,
  //   invitations: modifiedInvitations,
  //   storages: modifiedStorages,
  // } = modifiedOptions;
  // console.log(modifiedCustomers);

  const onFinish = async (values) => {
    // console.log(values);
    try {
      if (id) {
        const modifiedValue = {
          ...values,
          Options: values?.Options?.map((item) => Number(item)),
          Type: Number(values.Type),
          NodeType: Number(values.NodeType) || null,
          Channel: values.Channel || 0,
          Lockset: values.Lockset || 0,
          ContLock: values.ContLock || 0,
          Facegate: values.Facegate || 0,
          Subnode: values.Subnode || 0,
          Intercom: values.Intercom || 0,
          Sicucom: values.Sicucom || 0,
          Invitation: values.Invitation ? values.Invitation / 100 : 0,
          DealerNo: values?.DealerNo
            ? values?.DealerNo
            : ![1, 2, 3, 4, 5, 6].includes(userData?.role_value)
            ? data?.data?.DealerNo
            : null,
          CustomerNo: values?.CustomerNo
            ? values?.CustomerNo
            : ![1, 2, 3, 4, 5, 6, 7, 8, 9].includes(userData?.role_value)
            ? data?.data?.CustomerNo
            : null,
          OemNo: values?.OemNo
            ? values?.OemNo
            : ![1, 2, 3].includes(userData?.role_value)
            ? data?.data?.OemNo
            : null,
        };
        await putAction(modifiedValue);
      } else {
        const modifiedValue = {
          ...values,
          LicenseNo: selectedRow?.[0]?.LicenseNo,
          Options: values?.Options?.map((item) => Number(item)),
          Type: Number(values.Type),
          Channel: values.Channel || 0,
          Lockset: values.Lockset || 0,
          ContLock: values.ContLock || 0,
          Facegate: values.Facegate || 0,
          Subnode: values.Subnode || 0,
          Intercom: values.Intercom || 0,
          Sicucom: values.Sicucom || 0,
          Invitation: values.Invitation ? values.Invitation / 100 : 0,
          DealerNo: values?.DealerNo
            ? values?.DealerNo
            : hasRole(7, 8, 9)
            ? userData?.dealer_no
            : null,
          OemNo: values?.OemNo
            ? values?.OemNo
            : hasRole(7, 8, 9)
            ? userData?.oem_no
            : null,
        };
        await postAction(modifiedValue);
      }
    } catch (error) {
      openErrorNotification("Something went wrong.");
      console.log(error);
    }
  };

  const onReset = () => {
    navigate(-1);
  };

  const onDeleteConfirm = async () => {
    try {
      await deleteData();
    } catch (error) {
      openErrorNotification("Something went wrong.");
    }
    setShowModal(false);
  };

  useEffect(() => {
    // console.log("data", data);
    const getDeviceInfoById = () => {
      try {
        if (data?.data) {
          form.setFieldsValue({
            DeviceName: data?.data?.DeviceName,
            DeviceDesc: data?.data?.DeviceDesc,
            DealerNo: data?.data?.DealerNo,
            CustomerNo: data?.data?.CustomerNo,
            SiteType: data?.data?.SiteType,
            Type: data?.data?.Type,
            NodeType: data?.data?.NodeType,
            Options: data.data.Options?.map((item) => String(item)),
            Mac: data?.data?.Mac,
            Product: data?.data?.Product,
            Model: data?.data?.Model,
            OemNo: data?.data?.OemNo,
            StartTime: data?.data?.StartTime
              ? new Date(data.data.StartTime)
                  .toISOString()
                  .slice(0, 19)
                  .replace("T", " ")
              : null,
            EndTime: data?.data?.EndTime
              ? new Date(data.data.EndTime)
                  .toISOString()
                  .slice(0, 19)
                  .replace("T", " ")
              : null,
            // ProductionNo: data?.data?.ProductionNo,
            Channel: data?.data?.Channel,
            Lockset: data?.data?.Lockset,
            Facegate: data?.data?.Facegate,
            Subnode: data?.data?.Subnode,
            ContLock: data?.data?.ContLock,
            Intercom: data?.data?.Intercom,
            Sicucom: data?.data?.Sicucom,
            Invitation: data.data.Invitation ? data.data.Invitation * 100 : 0,
            // Storage: data?.data?.Storage,
            LicenseKey:
              data?.data?.LicenseKey !== null
                ? String(data?.data?.LicenseKey)
                : "",
            SiteKey:
              data?.data?.SiteKey !== null ? String(data?.data?.SiteKey) : "",
            FirstName: data?.data?.FirstName
              ? String(data?.data?.FirstName)
              : "",
            LastName: data?.data?.LastName ? String(data?.data?.LastName) : "",
            Company: data?.data?.Company ? String(data?.data?.Company) : "",
            Email: data?.data?.Email ? String(data?.data?.Email) : "",
            Phone: data?.data?.Phone ? String(data?.data?.Phone) : "",
            Address: data?.data?.Address ? String(data?.data?.Address) : "",
            Address2: data?.data?.Address2 ? String(data?.data?.Address2) : "",
            InstallType: data?.data?.InstallType
              ? String(data?.data?.InstallType)
              : "",
            Suggestion: data?.data?.Suggestion
              ? String(data?.data?.Suggestion)
              : "",
            ProxyNo: data?.data?.ProxyNo ? String(data?.data?.ProxyNo) : "",
            SecurePort: data?.data?.SecurePort
              ? String(data?.data?.SecurePort)
              : "",
            DebugPort: data?.data?.DebugPort
              ? String(data?.data?.DebugPort)
              : "",
            Timeout: data?.data?.Timeout ? String(data?.data?.Timeout) : "",
            Debug: data?.data?.Debug
              ? data?.data?.Debug === 0
                ? "No"
                : "Yes"
              : "",
            Version: data?.data?.Version ? String(data?.data?.Version) : "",
            Https: data?.data?.Https
              ? data?.data?.Https === 0
                ? "No"
                : "Yes"
              : "",
            Timezone: data?.data?.Timezone ? String(data?.data?.Timezone) : "",
            Online: data?.data?.Online
              ? data?.data?.Debug === 0
                ? "No"
                : "Yes"
              : "",
          });
          // setSelectedValues(data.data.Options || []);
          // setDefaultOptionsValue(data.data.Options || []);
          setDefaultData((prev) => ({
            ...prev,
            OemNo: data?.data?.OemNo || null,
            DealerNo: data?.data?.DealerNo || null,
            CustomerNo: data?.data?.CustomerNo || null,
            // ProductionNo: data?.data?.ProductionNo || null,
          }));

          // if (data.data.Options && modifiedOp) {
          // const filtered = modifiedOp
          //   .filter((op) => {
          //     const [item, originalValue] = op?.value?.split("-");
          //     return data?.data?.Options.some(
          //       ([selectedItem, selectedOriginalValue]) =>
          //         Number(item) === selectedItem &&
          //         Number(originalValue) === selectedOriginalValue
          //     );
          //   })
          //   .map((op) => op.value);
          // setSelectedValues(filtered || []);
          // setDefaultOptionsValue(filtered || []);
          // }
          // setDeafultModel(data.data.Model || null);
          setSiteType(data.data.SiteType || 0);
          setNodeType(data.data.NodeType || 0);
          // setDefaultLicenseDevicesValue({
          //   channels: data.data.Channel || null,
          //   locksets: data.data.Lockset || null,
          //   facegates: data.data.Facegate || null,
          //   contlocks: data.data.ContLock || null,
          //   subnodes: data.data.Subnode || null,
          //   intercoms: data.data.Intercom || null,
          //   sicucoms: data.data.Sicucom || null,
          //   invitations: data.data.Invitation || null,
          //   storages: data.data.Storage || null,
          // });
        } else {
          console.warn("No data found for the given ID");
        }
      } catch (error) {
        console.log({ error });
        openErrorNotification("Error fetching data!");
      }
    };

    getDeviceInfoById();
  }, [id, data, form]);

  //toat for create
  useEffect(() => {
    if (postError) {
      openErrorNotification(
        postError?.response?.data?.message || "Something went wrong"
      );
    } else if (!postError && postData) {
      openConfirmNotification("Success");
      navigate(-1);
    }
  }, [postError, postData]);

  //toat for update
  useEffect(() => {
    if (putError) {
      openErrorNotification(
        putError?.response?.data?.message || "Something went wrong"
      );
    } else if (!putError && putData) {
      openConfirmNotification("Success");
      refetch();
      navigate(-1);
      // navigate("/devicelist");
    }
  }, [putData, putError]);

  //toast for delete
  useEffect(() => {
    if (deletedData && !deletedDataError) {
      openConfirmNotification("Success");
      // refetch();
      navigate("/device");
    } else if (deletedDataError) {
      openErrorNotification(
        deletedDataError?.response?.data?.message || "Something went wrong"
      );
    } else {
      return;
    }
  }, [deletedData, deletedDataError]);

  // Set default field value
  useEffect(() => {
    if (!id) {
      form.setFieldsValue({
        // OemNo: modifiedOems[0]?.value,
        Product: modifiedProducts[0]?.value,
        Model: modifiedModels[0]?.value,
        Options: [],
        SiteType: modifiedSiteTypes[0]?.value,
        NodeType: modifiedNodeTypes[0]?.value,
        // NodeType: modifiedNodeTypes[0]?.value,
        // Channel: modifiedChannels[0]?.value,
        // Lockset: modifiedLocksets[0]?.value,
        // Facegate: modifiedFacegates[0]?.value,
        // Subnode: modifiedSubnodes[0]?.value,
        // ContLock: modifiedContLocks[0]?.value,
        // Intercom: modifiedIntercoms[0]?.value,
        // Sicucom: modifiedSicucoms[0]?.value,
        // Invitation: modifiedInvitations[0]?.value,
        // Storage: modifiedStorages[0]?.value,
      });
      // setOemNo(modifiedOems[0]?.value);
      // setDefaultData((prev) => ({
      //   ...prev,
      //   OemNo: modifiedOems[0]?.value,
      // }));
    }
  }, [optionsData]);
  useEffect(() => {
    if (data?.data?.SiteType && !form.getFieldValue("DealerNo")) {
      if (data?.data?.SiteType === 3 && type === "edit") {
        return;
      }
      if (id) {
        return;
      }
      form.setFieldsValue({
        SiteType: hasRole(7, 8, 9) ? data?.data?.SiteType : 0,
      });
    }
  }, [form.getFieldValue("DealerNo")]);

  const handleCreateNew = (type) => {
    setModalType(type);
    setIsOpenModal(true);
  };

  useEffect(() => {
    optionDataRefetch();
    delaerOpRefetch();
    customerDataRefetch();
    if (
      defaultData?.OemNo ||
      defaultData?.DealerNo ||
      defaultData?.CustomerNo
      // ||
      // defaultData?.ProductionNo
    ) {
      form.setFieldsValue(defaultData);
    }
  }, [defaultData]);
  // console.log(form.getFieldValue("DealerNo"), "DealerNo");
  useEffect(() => {
    if (data?.data?.SiteType === 3 && type === "edit") {
      return;
    }
    if (!form.getFieldValue("DealerNo") && !id) {
      form.setFieldsValue({
        SiteType: hasRole(7, 8, 9) ? 3 : 0,
      });
    } else if (
      form.getFieldValue("DealerNo") &&
      licenseSiteType &&
      type !== "edit" &&
      type !== "info"
    ) {
      form.setFieldsValue({
        SiteType: licenseSiteType,
      });
    }
  }, [form.getFieldValue("DealerNo"), form.getFieldValue("OemNo")]);

  const breadcrumbItems = [
    {
      label: "Device",
      href: "/device",
    },
    {
      label: id ? (type === "info" ? "Information" : "Edit") : "Add",
      href: id
        ? type === "info"
          ? `/device/info/${id}`
          : `/device/edit/${id}`
        : "/device/add",
    },
  ];

  const buttonsData =
    type === "info"
      ? [1, 2, 3].includes(userData?.role_value)
        ? [
            {
              label: "Edit",
              icon: <EditOutlined />,
              onClick: () => {
                navigate(`/device/edit/${id}`);
              },
            },
            {
              label: "Delete",
              icon: <DeleteOutlined />,
              onClick: () => {
                setShowModal(true);
              },
            },
            {
              label: "List",
              icon: <UnorderedListOutlined />,
              onClick: () => {
                navigate(-1);
              },
            },
          ]
        : [4, 5, 6, 7, 8, 9].includes(userData?.role_value)
        ? [
            {
              label: "Edit",
              icon: <EditOutlined />,
              onClick: () => {
                navigate(`/device/edit/${id}`);
              },
            },
            {
              label: "List",
              icon: <UnorderedListOutlined />,
              onClick: () => {
                navigate(-1);
              },
            },
          ]
        : [
            {
              label: "List",
              icon: <UnorderedListOutlined />,
              onClick: () => {
                navigate(-1);
              },
            },
          ]
      : type === "edit"
      ? [
          {
            label: "Apply",
            icon: <CheckCircleOutlined />,
            onClick: () => form.submit(),
            loading: postLoading || putLoading,
          },
          {
            label: "Cancel",
            icon: <CloseOutlined />,
            onClick: onReset,
          },
        ]
      : hasRole(7, 8, 9)
      ? [
          {
            label: "Apply",
            icon: <CheckCircleOutlined />,
            onClick: () => form.submit(),
            loading: postLoading || putLoading,
          },
          {
            label: "Cancel",
            icon: <CloseOutlined />,
            onClick: onReset,
          },
        ]
      : [
          {
            label: "License Select",
            icon: <FolderOpenOutlined />,
            onClick: () => {
              setShowCommonModal(true);
            },
          },
          {
            label: "Apply",
            icon: <CheckCircleOutlined />,
            onClick: () => form.submit(),
            loading: postLoading || putLoading,
          },
          {
            label: "Cancel",
            icon: <CloseOutlined />,
            onClick: onReset,
          },
        ];

  // const isOneTime = (category, valueToCheck) => {
  //   return optionsData?.data?.[category]
  //     ?.filter((item) => item.tag === "One Time")
  //     ?.map((item) => item.value)
  //     ?.includes(valueToCheck);
  // };

  // const modifiedOneTimeOptions = isOneTime("models", deafultModel);
  // const isChannelOneTime = isOneTime(
  //   "channels",
  //   defaultLicenseDevicesValue.channels
  // );
  // const isLocksetOneTime = isOneTime(
  //   "locksets",
  //   defaultLicenseDevicesValue.locksets
  // );
  // const isFacegatesOneTime = isOneTime(
  //   "facegates",
  //   defaultLicenseDevicesValue.facegates
  // );
  // const isSubnodesOneTime = isOneTime(
  //   "subnodes",
  //   defaultLicenseDevicesValue.subnodes
  // );
  // const isContLocksOneTime = isOneTime(
  //   "contlocks",
  //   defaultLicenseDevicesValue.contlocks
  // );
  // const isIntercomsOneTime = isOneTime(
  //   "intercoms",
  //   defaultLicenseDevicesValue.intercoms
  // );
  // const isSicucomsOneTime = isOneTime(
  //   "sicucoms",
  //   defaultLicenseDevicesValue.sicucoms
  // );
  // const isInvitationsOneTime = isOneTime(
  //   "invitations",
  //   defaultLicenseDevicesValue.invitations
  // );
  // const isStoragesOneTime = isOneTime(
  //   "storages",
  //   defaultLicenseDevicesValue.storages
  // );

  useEffect(() => {
    if (
      id &&
      type === "edit" &&
      [3, 6, 10, 11, 12].includes(userData?.role_value)
    ) {
      navigate("/");
    }
  }, []);
  // console.log(licenseSiteType, "licenseSiteType");
  return (
    <div>
      <AccountCreationModal
        isOpenModal={isOpenModal}
        modalType={modalType}
        setIsOpenModal={setIsOpenModal}
        setDefaultData={setDefaultData}
        defaultData={defaultData}
        setModalType={setModalType}
        isModal={true}
        isModalForm={true}
        title={
          <div className="flex items-center bg-gray-200 p-2 rounded-md">
            {modalType === "OEM" ? (
              <OemIcon className="text-[15px] text-black ml-1" />
            ) : modalType === "Dealer" ? (
              <DealerIcon className="text-[15px] text-black ml-1" />
            ) : modalType === "Customer" ? (
              <AccountIcon className="text-[15px] text-black ml-1" />
            ) : null}
            <span className="text-[14px] font-[Poppins] text-black  ml-2">
              {isOpenModal ? `Add ${modalType}` : "Send Invitation"}
            </span>
          </div>
        }
      />
      <CommonModal
        title="Select License"
        icon={LicenseIcon}
        content={
          <LicenseSelectForm
            setSelectedRow={setSelectedRow}
            type="Initial License"
          />
        }
        isVisible={showCommonModal}
        onClose={() => setShowCommonModal(false)}
        width={900}
        onConfirm={() => {
          if (!individualLicenseData?.data) {
            openErrorNotification("Please select a license before apply.");
            return;
          }
          setSiteType(individualLicenseData.data.SiteType);
          form.setFieldsValue({
            Options: individualLicenseData?.data?.Options?.map((item) =>
              String(item)
            ),
            Product: individualLicenseData?.data?.Product,
            Model: individualLicenseData?.data?.Model,
            Type: individualLicenseData.data.Type,
            SiteType: !form.getFieldValue("DealerNo")
              ? 0
              : individualLicenseData.data.SiteType,
            // OemNo: individualLicenseData.data.OemNo,
            Invitation: individualLicenseData.data.Invitation
              ? individualLicenseData.data.Invitation * 100
              : undefined,
            Channel: individualLicenseData.data.Channel,
            Lockset: individualLicenseData.data.Lockset,
            Facegate: individualLicenseData.data.Facegate,
            Subnode: individualLicenseData.data.Subnode,
            ContLock: individualLicenseData.data.ContLock,
            Intercom: individualLicenseData.data.Intercom,
            Sicucom: individualLicenseData.data.Sicucom,
            // Storage: individualLicenseData.data.Storage,
          });
          setLicenseSiteType(individualLicenseData.data.SiteType);
          // if (individualLicenseData?.data?.Options && modifiedOp) {
          // const filtered = modifiedOp
          //   .filter((op) => {
          //     const [item, originalValue] = op?.value?.split("-");
          //     return individualLicenseData?.data?.Options.some(
          //       ([selectedItem, selectedOriginalValue]) =>
          //         Number(item) === selectedItem &&
          //         Number(originalValue) === selectedOriginalValue
          //     );
          //   })
          //   .map((op) => op.value);
          //   setSelectedValues(individualLicenseData?.data?.Options || []);
          // }
          setShowCommonModal(false);
        }}
      />
      <div className="pb-4 sticky -mt-4 pt-[6px] top-[55px] z-10 bg-[#f4f5f9]">
        <CommonBreadcrumb breadcrumbItems={breadcrumbItems}>
          <CommonButton buttonsData={buttonsData} />
        </CommonBreadcrumb>
      </div>

      <div className="">
        <Form
          validateTrigger={"onChange"}
          form={form}
          onFinish={onFinish}
          scrollToFirstError
          layout={"vertical"}
          autoComplete={"off"}
          // onValuesChange={(changedValues) => {
          //   console.log("Changed Field:", changedValues);
          // }}
        >
          <div className="overflow-hidden border bg-white rounded-[4px]">
            <div className="flex items-center bg-gray-200 p-2.5">
              <DeviceIcon className="text-[18px] text-black " />
              <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                Device
              </span>
            </div>
            <div className="px-2 pt-1 pb-3">
              <Row gutter={[16, 8]}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="Device Name"
                    name="DeviceName"
                    disable={type === "info"}
                    // required
                  />
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="Description"
                    name="DeviceDesc"
                    disable={type === "info"}
                  />
                </Col>
                {/* {[1, 2, 3].includes(userData?.role_value) && (
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomSelect
                      label="Production"
                      name="ProductionNo"
                      options={modifiedProductions}
                      placeholder="Please select"
                      disabled={type === "info"}
                      handleCreateNew={handleCreateNew}
                      type={"Production"}
                      onChange={(value) => {
                        setDefaultData((prev) => ({
                          ...prev,
                          ProductionNo: value,
                        }));
                        form.setFieldsValue({
                          ProductionNo: value,
                        });
                      }}
                    />
                  </Col>
                )} */}
                {[1, 2, 3].includes(userData?.role_value) && (
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomSelect
                      label="OEM"
                      name="OemNo"
                      options={modifiedOems}
                      placeholder="Please select"
                      // value={form.getFieldValue("OemNo")}
                      disabled={type === "info"}
                      required
                      onChange={(value) => {
                        setDefaultData((prev) => ({
                          ...prev,
                          OemNo: value,
                          DealerNo: null,
                          CustomerNo: null,
                        }));
                        setOemNo(value);
                        setDealerNo(null);
                        form.setFieldsValue({
                          DealerNo: null,
                          CustomerNo: null,
                        });
                      }}
                      handleCreateNew={handleCreateNew}
                      type={"OEM"}
                      allowClear={false}
                    />
                  </Col>
                )}
                {[1, 2, 3, 4, 5, 6].includes(userData?.role_value) && (
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomSelect
                      label="Dealer"
                      name="DealerNo"
                      options={modifiedDealers}
                      placeholder="Please select"
                      disabled={type === "info" || !defaultData?.OemNo}
                      onChange={(value) => {
                        setDefaultData((prev) => ({
                          ...prev,
                          DealerNo: value,
                          CustomerNo: null,
                        }));
                        setDealerNo(value);
                        form.setFieldsValue({
                          CustomerNo: null,
                        });
                      }}
                      handleCreateNew={handleCreateNew}
                      type={"Dealer"}
                      // customPlaceholderColor
                    />
                  </Col>
                )}
                {[1, 2, 3, 4, 5, 6, 7, 8, 9].includes(userData?.role_value) && (
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomSelect
                      label="Customer"
                      name="CustomerNo"
                      options={modifiedCustomers}
                      placeholder="Please select"
                      disabled={
                        type === "info" || hasRole(7, 8, 9)
                          ? !OemNo && !dealerNo
                          : !defaultData?.DealerNo
                      }
                      handleCreateNew={handleCreateNew}
                      type={"Customer"}
                    />
                  </Col>
                )}

                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomSelect
                    label="Node Type"
                    name="NodeType"
                    options={modifiedNodeTypes}
                    placeholder="Please select"
                    disabled={type === "info" || hasRole(7, 8, 9)}
                    onChange={(value) => {
                      setNodeType(value);
                    }}
                  />
                </Col>
                {/* {console.log("SiteType", sitetype)} */}

                {[0, 1, 2].includes(sitetype) || type === "info" ? (
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="MAC"
                      name="Mac"
                      disable={id || type === "info"}
                      required={[0, 1, 2].includes(sitetype)}
                      rules={[{ validator: macValidator }]}
                    />
                  </Col>
                ) : null}
                {type === "info" && [0, 1, 2].includes(sitetype) ? (
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Site Key"
                      name="SiteKey"
                      disabled={type === "info"}
                    />
                  </Col>
                ) : null}
                {type === "info" && data?.data?.LicenseKey && (
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="License Key"
                      name="LicenseKey"
                      disabled={type === "info"}
                    />
                  </Col>
                )}
                {/* <Col xs={24} sm={24} md={12} lg={12} xl={12} className="mt-2 ">
                  <CustomSwitch
                    label="Expired"
                    name="Expired"
                    defaultChecked={0}
                    disabled={type === "info"}
                  />
                </Col> */}
              </Row>
              <Row gutter={[16, 4]} className="mt-1">
                {/* {type === "info" && (
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Site Key"
                      name="SiteKey"
                      disabled={type === "info"}
                    />
                  </Col>
                )} */}
              </Row>
            </div>
          </div>
          <div className="mt-4 border bg-white rounded-[4px] overflow-hidden">
            <div className="flex items-center bg-gray-200 p-2.5">
              <InfoCircleOutlined className="text-[18px] text-black " />
              <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                License Information
              </span>
            </div>
            <div className="px-2 pt-1 pb-3">
              <Row gutter={[16, 8]}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomSelect
                    label="Product"
                    name="Product"
                    options={
                      type === "edit" &&
                      [3, 4].includes(sitetype) &&
                      form.getFieldValue("Product") !== 0
                        ? modifiedProducts.filter(
                            (item) =>
                              item.value === form.getFieldValue("Product")
                          )
                        : [3, 4].includes(sitetype)
                        ? modifiedProducts.filter((item) => item.value === 0)
                        : modifiedProducts
                    }
                    placeholder="Please select"
                    disabled={
                      type === "info" ||
                      // hasRole(7, 8, 9) ||
                      (type === "edit" &&
                        [3, 4].includes(sitetype) &&
                        form.getFieldValue("Product") !== 0)
                    }
                    required
                    allowClear={!type}
                  />
                </Col>
                {/* {nodeType === 1 && ( */}
                {console.log(modifiedSiteTypes)}

                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomSelect
                    label="Site Type"
                    name="SiteType"
                    options={
                      ["edit", "info"].includes(type)
                        ? form.getFieldValue("SiteType") === 3
                          ? modifiedSiteTypes?.filter(
                              (item) => item.value === 3
                            )
                          : form.getFieldValue("SiteType") === 4
                          ? modifiedSiteTypes?.filter(
                              (item) => item.value === 4
                            )
                          : modifiedSiteTypes?.filter(
                              (item) => ![3, 4].includes(item.value)
                            )
                        : modifiedSiteTypes
                    }
                    placeholder="Please select"
                    disabled={type === "info"}
                    onChange={(value) => {
                      setSiteType(value);
                      if (
                        [3, 4].includes(value) &&
                        form.getFieldValue("Product") !== 0
                      ) {
                        form.setFieldValue("Product", 0);
                      }
                    }}
                    allowClear={false}
                  />
                </Col>
                {/* )} */}
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomSelect
                    label="Model"
                    name="Model"
                    options={modifiedModels}
                    placeholder="Please select"
                    disabled={type === "info"}
                    required
                  />
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="Door"
                    name="Type"
                    disabled={type === "info"}
                    type="number"
                    required
                    rules={[
                      {
                        required: true,
                        message: "Door is required",
                      },
                      {
                        validator: (_, value) => {
                          if (value && value > 255) {
                            return Promise.reject(
                              new Error(
                                "Door must be less than or equal to 255!"
                              )
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  />
                </Col>
                {[2, 3].includes(form.getFieldValue("SiteType")) &&
                  type === "info" && (
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Start Time"
                        name="StartTime"
                        disabled
                      />
                    </Col>
                  )}
                {[2, 3].includes(form.getFieldValue("SiteType")) &&
                  type === "info" && (
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput label="End Time" name="EndTime" disabled />
                    </Col>
                  )}
                {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomSelect
                    label="OEM"
                    name="OemNo"
                    options={modifiedOems}
                    placeholder="Please select"
                    // value={form.getFieldValue("OemNo")}
                    disabled={type === "info"}
                    required
                    onChange={(value) => {
                      setOemNo(value);
                      setDealerNo(null);
                      form.setFieldsValue({
                        DealerNo: null,
                        CustomerNo: null,
                      });
                    }}
                  />
                </Col> */}
              </Row>
              {/* <Row gutter={[16, 8]}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="Type"
                    name="Type"
                    type="number"
                    disabled={type === "info"}
                    required
                  />
                </Col>
              
              </Row> */}
            </div>
          </div>
          <div className="mt-4 border bg-white rounded-[4px] overflow-hidden">
            <div className="flex items-center bg-gray-200 p-2.5">
              <SettingOutlined className="text-[18px] text-black " />
              <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                License Options
              </span>
            </div>
            <div className="px-2 py-3 grid gap-4">
              {/* <Row gutter={[16, 16]} className="p-2"> */}
              <CustomCheckbox
                label=""
                name="Options"
                options={modifiedOp}
                disabled={type === "info"}
              />
              {/* {modifiedOp?.length > 0 && (
                <SingleSelectCheckboxGroup
                  options={modifiedOp}
                  type={
                    type === "edit"
                      ? userData?.role_value >= 10
                        ? "info"
                        : "edit"
                      : type
                  }
                  name="Options"
                  onChange={(vals) => setSelectedValues(vals)}
                  defaultOptionsValue={selectedValues}
                  staticOptions={defaultOptionsValue}
                  disabled={type === "info" || userData?.role_value >= 10}
                />
              )} */}

              {/* </Row> */}
            </div>
          </div>

          <div className="mt-4 border bg-white rounded-[4px] overflow-hidden">
            <div className="flex items-center bg-gray-200 p-2.5">
              <DesktopOutlined className="text-[18px] text-black " />
              <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                License Devices
              </span>
            </div>

            <div className="px-2 pt-1 pb-3">
              <Row gutter={[16, 8]}>
                {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Camera"
                        name="Camera"
                        disabled={type === "info"}
                        type="number"
                        required
                      />
                    </Col> */}
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="Channel"
                    name="Channel"
                    disabled={type === "info"}
                    type="number"
                    rules={[
                      {
                        validator: (_, value) => {
                          if (value && value > 255) {
                            return Promise.reject(
                              new Error(
                                "Channel must be less than or equal to 255!"
                              )
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  />
                  {/* <CustomSelect
                    label="Channel"
                    name="Channel"
                    options={
                      // isChannelOneTime
                      //   ? modifiedChannels.filter((item) =>
                      //       item.label?.includes("One Time")
                      //     )
                      //   :
                      modifiedChannels
                    }
                    placeholder="Please select"
                    disabled={type === "info"}
                  /> */}
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="Lockset"
                    name="Lockset"
                    disabled={type === "info"}
                    type="number"
                    rules={[
                      {
                        validator: (_, value) => {
                          if (value && value > 255) {
                            return Promise.reject(
                              new Error(
                                "Lockset must be less than or equal to 255!"
                              )
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  />
                  {/* <CustomSelect
                    label="Lockset"
                    name="Lockset"
                    options={
                      // isLocksetOneTime
                      //   ? modifiedLocksets.filter((item) =>
                      //       item.label?.includes("One Time")
                      //     )
                      //   :
                      modifiedLocksets
                    }
                    placeholder="Please select"
                    disabled={type === "info"}
                  /> */}
                </Col>

                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="Facegate"
                    name="Facegate"
                    disabled={type === "info"}
                    type="number"
                    rules={[
                      {
                        validator: (_, value) => {
                          if (value && value > 255) {
                            return Promise.reject(
                              new Error(
                                "Facegate must be less than or equal to 255!"
                              )
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  />
                  {/* <CustomSelect
                    label="Facegate"
                    name="Facegate"
                    options={
                      // isFacegatesOneTime
                      //   ? modifiedFacegates.filter((item) =>
                      //       item.label?.includes("One Time")
                      //     )
                      //   :
                      modifiedFacegates
                    }
                    placeholder="Please select"
                    disabled={type === "info"}
                  /> */}
                </Col>

                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="OSDP Device"
                    name="Subnode"
                    disabled={type === "info"}
                    type="number"
                    rules={[
                      {
                        validator: (_, value) => {
                          if (value && value > 255) {
                            return Promise.reject(
                              new Error(
                                "OSDP Device must be less than or equal to 255!"
                              )
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  />
                  {/* <CustomSelect
                    label="OSDP Device"
                    name="Subnode"
                    options={
                      // isSubnodesOneTime
                      //   ? modifiedSubnodes.filter((item) =>
                      //       item.label?.includes("One Time")
                      //     )
                      //   :
                      modifiedSubnodes
                    }
                    placeholder="Please select"
                    disabled={type === "info"}
                  /> */}
                </Col>

                {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Subnode"
                        name="Subnode"
                        disabled={type === "info"}
                        type="number"
                        required
                      />
                    </Col> */}

                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="Trilogy Lockset"
                    name="ContLock"
                    disabled={type === "info"}
                    type="number"
                    rules={[
                      {
                        validator: (_, value) => {
                          if (value && value > 255) {
                            return Promise.reject(
                              new Error(
                                "Trilogy Lockset must be less than or equal to 255!"
                              )
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  />
                  {/* <CustomSelect
                    label="Trilogy Lockset"
                    name="ContLock"
                    options={
                      // isContLocksOneTime
                      //   ? modifiedContLocks.filter((item) =>
                      //       item.label?.includes("One Time")
                      //     )
                      //   :
                      modifiedContLocks
                    }
                    placeholder="Please select"
                    disabled={type === "info"}
                  /> */}
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="Intercom"
                    name="Intercom"
                    disabled={type === "info"}
                    type="number"
                    rules={[
                      {
                        validator: (_, value) => {
                          if (value && value > 255) {
                            return Promise.reject(
                              new Error(
                                "Intercom must be less than or equal to 255!"
                              )
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  />
                  {/* <CustomSelect
                    label="Intercom"
                    name="Intercom"
                    options={
                      // isIntercomsOneTime
                      //   ? modifiedIntercoms.filter((item) =>
                      //       item.label?.includes("One Time")
                      //     )
                      //   :
                      modifiedIntercoms
                    }
                    placeholder="Please select"
                    disabled={type === "info"}
                  /> */}
                </Col>

                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="Directory"
                    name="Sicucom"
                    disabled={type === "info"}
                    type="number"
                    rules={[
                      {
                        validator: (_, value) => {
                          if (value && value > 255) {
                            return Promise.reject(
                              new Error(
                                "Directory must be less than or equal to 255!"
                              )
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  />
                  {/* <CustomSelect
                    label="Directory"
                    name="Sicucom"
                    options={
                      // isSicucomsOneTime
                      //   ? modifiedSicucoms.filter((item) =>
                      //       item.label?.includes("One Time")
                      //     )
                      //   :
                      modifiedSicucoms
                    }
                    placeholder="Please select"
                    disabled={type === "info"}
                  /> */}
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomSelect
                    label="Mobile Credential"
                    name="Invitation"
                    options={Array.from(
                      { length: (25500 - 100) / 100 + 1 },
                      (_, i) => {
                        const value = 100 + i * 100;
                        return {
                          value,
                          label: `${value}`,
                        };
                      }
                    )}
                    placeholder="Please select"
                    disabled={type === "info"}
                  />
                  {/* <CustomSelect
                    label="Invitation"
                    name="Invitation"
                    options={
                      // isInvitationsOneTime
                      //   ? modifiedInvitations.filter((item) =>
                      //       item.label?.includes("One Time")
                      //     )
                      //   :
                      modifiedInvitations
                    }
                    placeholder="Please select"
                    disabled={type === "info"}
                  /> */}
                </Col>
              </Row>

              {/* <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}> */}
              {/* <CustomInput
                        label="Storage"
                        name="Storage"
                        disabled={type === "info"}
                        type="number"
                        required
                      /> */}
              {/* <CustomSelect
                    label="Storage"
                    name="Storage"
                    options={
                      // isStoragesOneTime
                      //   ? modifiedStorages.filter((item) =>
                      //       item.label?.includes("One Time")
                      //     )
                      //   :
                      modifiedStorages
                    }
                    placeholder="Please select"
                    disabled={type === "info"}
                  />
                </Col>
              </Row> */}
            </div>
          </div>

          {type === "info" && data?.data?.Guest ? (
            <div className="mt-4 bg-white rounded-[4px] overflow-hidden">
              <div className="flex items-center bg-gray-200 p-2.5 ">
                <InfoCircleOutlined className="text-[18px] text-black " />
                <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                  Customer Information
                </span>
              </div>
              <div className="px-2 pt-1 pb-3">
                <Row gutter={[16, 8]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="First Name"
                      name="FirstName"
                      disabled={type === "info"}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Last Name"
                      name="LastName"
                      disabled={type === "info"}
                    />
                  </Col>
                </Row>
                <Row gutter={[16, 8]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Installing Company"
                      name="Company"
                      disabled={type === "info"}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Email"
                      name="Email"
                      disabled={type === "info"}
                    />
                  </Col>
                </Row>
                <Row gutter={[16, 8]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Phone"
                      name="Phone"
                      disabled={type === "info"}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Address"
                      name="Address2"
                      disabled={type === "info"}
                    />
                  </Col>
                </Row>
                <Row gutter={[16, 8]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Install Type"
                      name="InstallType"
                      disabled={type === "info"}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Suggestion"
                      name="Suggestion"
                      disabled={type === "info"}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          ) : null}
          {/* {type === "info" && (
            <div className="mt-4 bg-white rounded-[4px] overflow-hidden">
              <div className="flex items-center bg-gray-200 p-2.5 ">
                <InfoCircleOutlined className="text-[18px] text-black " />
                <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                  Device Status
                </span>
              </div>
              <div className="px-2 pt-1 pb-3">
                <Row gutter={[16, 8]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Proxy Server"
                      name="ProxyNo"
                      disabled={type === "info"}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Secure Port"
                      name="SecurePort"
                      disabled={type === "info"}
                    />
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Debug Port"
                      name="DebugPort"
                      disabled={type === "info"}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Version"
                      name="Version"
                      disabled={type === "info"}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Timeout"
                      name="Timeout"
                      disabled={type === "info"}
                    />
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Debug"
                      name="Debug"
                      disabled={type === "info"}
                    />
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Address"
                      name="Address"
                      disabled={type === "info"}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="HTTPS"
                      name="Https"
                      disabled={type === "info"}
                    />
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Timezone"
                      name="Timezone"
                      disabled={type === "info"}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Online"
                      name="Online"
                      disabled={type === "info"}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          )} */}
        </Form>
        {type === "info" && (
          <div className="mt-4 border bg-white rounded-[4px] overflow-hidden">
            <div className="bg-gray-200">
              <div className="py-[5.748px] px-2.5 custom-segmented">
                <Segmented
                  options={deviceTabs}
                  size="middle"
                  onChange={(value) => {
                    setTabValue(value);
                  }}
                  // defaultValue={deviceTabs[0].value}
                  className="!bg-transparent !text-black"
                />
              </div>
              {tabValue === "deviceLog" ? (
                <GlobalTable
                  columns={DeviceLogItemColumns()}
                  dataSource={deviceLogData?.data}
                  loading={deviceLogLoading}
                />
              ) : (
                <GlobalTable
                  columns={DeviceOrderItemColumns()}
                  dataSource={deviceLogOrderData?.data}
                  loading={deviceLogOrderLoading}
                />
              )}
            </div>
          </div>
        )}
      </div>

      <ConfirmModal
        showModal={showModal}
        setShowModal={setShowModal}
        onDeleteConfirm={onDeleteConfirm}
      />
    </div>
  );
};
